exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* @import '@/assets/theme_gold/css/bank-card.css'; */\n.popup-body .btn-style-outline-secondary[data-v-6433410a] {\n  color: #B1A781;\n  border: 1px solid #B1A781;\n  background-color: transparent;\n}\n.popup-body .btn-style-outline-secondary[data-v-6433410a]:hover,\n.popup-body .btn-style-outline-secondary[data-v-6433410a]:focus {\n\tcolor: #FFF;\n\tborder: 1px solid #B1A781;\n\tbackground-color: #B1A781;\n}\n.popup-frame.popup-card-edit[data-v-6433410a] {\n  display: none;\n}\n.popup-frame.popup-card-edit.active[data-v-6433410a] {\n  display: block;\n}\n\n", ""]);

// exports
